import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const RedirectComponent = () => {
  const [count, setCount] = useState(6);
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    const interval = setInterval(() => {
      setCount((currentCount) => currentCount - 1);
    }, 1000);
    count === 0 && navigate('/login');
    return () => clearInterval(interval);
  }, [count, navigate]);
  return <span>{t('redirect_to_login_info', { count })} </span>;
};

export default RedirectComponent;
